import { render, staticRenderFns } from "./CompanyValues.vue?vue&type=template&id=683dd5d2&"
var script = {}
import style0 from "./CompanyValues.vue?vue&type=style&index=0&id=683dd5d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports